import styled from "styled-components";

export const ReferralContainer = styled.div`
  border-radius: var(--rounding-radius-xl, 24px);
  background: rgba(252, 252, 3, 0.24);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  font-size: 16px;
  display: grid;
  grid-template-areas:
    "label button"
    "url button";
  row-gap: 0;
  height: 80px;
  &.borders-sm {
    border-radius: 16px;
  }
`;

export const ReferralLabel = styled.div`
  grid-area: label;
  text-align: left;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: var(--text-secondary, rgba(242, 237, 235, 0.48));
`;

export const ReferralUrl = styled.div`
  grid-area: url;
  color: var(--text-primary);
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-align: left;
`;

export const ReferralCopyButton = styled.button`
  cursor: pointer;
  grid-area: button;
  outline: none;
  background: transparent;
  color: var(--text-primary, #faf8f7);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  font-variation-settings: "wght" 700;
  line-height: normal;
  letter-spacing: 0.48px;
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 16px;
  transition: 300ms ease-out;
  height: 32px;

  &:hover {
    background: rgba(204, 187, 184, 0.16);
  }
`;
